module.exports = __webpack_public_path__ + "img/login-left.969947fc.png";